 <section id="container" [ngClass]="{'sidebar-closed': sideNavService.hideSideNav }" *ngIf="authService.isLoggedIn()">
  <!--header start-->
  <app-header></app-header>
  <!--header end-->
  <!--sidebar start-->
  <app-sidemenu></app-sidemenu>
  <!--sidebar end-->
  <!--main content start-->
  <section id="main-content">
    <section class="wrapper">
      <!-- page start-->
      <div class="row">
        <div class="col-lg-12">
          <ul class="breadcrumb">
            <li><a href="#"><i class="fa fa-home"></i> Home</a></li>
            <li><a href="#"> Change Password</a></li>
          </ul>
        </div>

      </div>
      <div class="row">
        <div class="col-sm-12">
         <!--collapse start-->
         <div class="panel-group m-bot20" id="accordion">

          <form class="form-horizontal" #ngForm="ngForm" [formGroup]="loggedInUserForm" (ngSubmit)="submitForm()">
           <div class="panel panel-default">

            <div class="panel-heading">
              <h4 class="panel-title">
                <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseOne">
                  Change Password
                </a>
              </h4>
            </div>
            <div id="collapseOne" class="panel-collapse collapse in">
              <div class="panel-body form-horizontal">

                <div class="alert alert-danger fade in" *ngIf="formSubmitted && !formResult">
                  <button data-dismiss="alert" class="close close-sm" type="button">
                    <i class="fa fa-times"></i>
                  </button>
                  {{formResultMessage}}
                </div>

                <div class="alert alert-success fade in" *ngIf="formSubmitted && formResult">
                  <button data-dismiss="alert" class="close close-sm" type="button">
                    <i class="fa fa-times"></i>
                  </button>
                  {{formResultMessage}}
                </div>

                <div class="col-sm-12">

                  <div class="form-group">
                    <label for="name" class="col-sm-2 control-label">Old Password</label>
                    <div class="col-sm-6">
                      <input type="password" class="form-control" formControlName="old_password" placeholder="Old Password">
                      <p class="error-block" *ngIf="submitClicked && loggedInUserForm.get('old_password').invalid && (loggedInUserForm.get('old_password').dirty || ngForm.submitted)"><span *ngIf="loggedInUserForm.controls['old_password'].errors.required">Please Enter Old Password</span></p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="name" class="col-sm-2 control-label">New Password</label>
                    <div class="col-sm-6">
                      <input type="password" class="form-control" formControlName="new_password" placeholder="New Password">
                      <p class="error-block" *ngIf="submitClicked && loggedInUserForm.get('new_password').invalid && (loggedInUserForm.get('new_password').dirty  || ngForm.submitted)"><span *ngIf="loggedInUserForm.controls['new_password'].errors.required">Please Enter New Password</span></p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="name" class="col-sm-2 control-label">Retype New Password</label>
                    <div class="col-sm-6">
                      <input type="password" class="form-control" formControlName="retype_new_password" placeholder="Retype New Password">
                      <p class="error-block" *ngIf="submitClicked && loggedInUserForm.get('retype_new_password').invalid && (loggedInUserForm.get('retype_new_password').dirty  || ngForm.submitted)"><span *ngIf="loggedInUserForm.controls['retype_new_password'].errors.required">Please Retype New Password</span></p>
                    </div>
                  </div>
                  <div class="form-group" >
                    <div class="col-sm-2"></div>
                    <div class="col-sm-2">
                      <input type="submit" class="btn btn-primary" value="Update Password"/>
                    </div>
                  </div>

                  <div *ngIf="submittingForm" class="d-flex justify-content-center">
                    <div class="spinner-border m-5" style="color:#c02429" role="status">
                      <span class="sr-only">Submitting form...</span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </form>
      </div>

      <!--collapse end-->

    </div>

  </div>

  <!-- page end-->
</section>
</section>
<!--main content end-->
<!-- Right Slidebar start -->

<!-- Right Slidebar end -->
<!--footer start-->
<app-footer></app-footer>
<!--footer end-->
</section>


<!--collapse start-->
<div class="resetpass" *ngIf="!authService.isLoggedIn()">
  <div class="panel-group m-bot20" id="accordion">
      <form class="form-horizontal" #ngForm="ngForm" [formGroup]="nonLoggedInUserForm" (ngSubmit)="submitForm()">
       <div class="panel panel-default">
        <div class="panel-heading">
          <h4 class="panel-title" style="text-align: center;">Reset Password</h4>
        </div>
        <div id="collapseOne" class="panel-collapse collapse in">
          <div class="panel-body form-horizontal">
            
            <div class="alert alert-danger fade in" *ngIf="formSubmitted && !formResult">
              <button data-dismiss="alert" class="close close-sm" type="button">
                <i class="fa fa-times"></i>
              </button>
              {{formResultMessage}}
            </div>

            <div class="alert alert-success fade in" *ngIf="formSubmitted && formResult">
              <button data-dismiss="alert" class="close close-sm" type="button">
                <i class="fa fa-times"></i>
              </button>
              {{formResultMessage}}
            </div>

            <div class="col-sm-12 text-center" *ngIf="formResult"><a class="gotologin" href="/">Go to login</a></div>
            <div class="col-sm-12" *ngIf="!formResult">
              <div class="form-group">
                <div class="col-sm-12">
                  <input type="password" class="form-control" formControlName="new_password" placeholder="Type New Password">
                  <p class="error-block" *ngIf="submitClicked && nonLoggedInUserForm.get('new_password').invalid && (nonLoggedInUserForm.get('new_password').dirty  || ngForm.submitted)"><span *ngIf="nonLoggedInUserForm.controls['new_password'].errors.required">Type New Password</span></p>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-12">
                  <input type="password" class="form-control" formControlName="retype_new_password" placeholder="Retype New Password">
                  <p class="error-block" *ngIf="submitClicked && nonLoggedInUserForm.get('retype_new_password').invalid && (nonLoggedInUserForm.get('retype_new_password').dirty  || ngForm.submitted)"><span *ngIf="nonLoggedInUserForm.controls['retype_new_password'].errors.required">Retype New Password</span></p>
                </div>
              </div>

              <div class="form-group" >
                <div class="col-sm-12 text-center">
                  <input type="submit" class="btn btn-primary" value="Update Password"/>
                </div>
              </div>
              
              <div *ngIf="submittingForm" class="d-flex justify-content-center">
                <div class="spinner-border m-5" style="color:#c02429" role="status">
                  <span class="sr-only">Submitting form...</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<!--collapse end-->